// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes display {
  0% {
    transform: translateX(200px);
    opacity: 0;
  }
  10% {
    transform: translateX(0);
    opacity: 1;
  }
  20% {
    transform: translateX(0);
    opacity: 1;
  }
  30% {
    transform: translateX(-200px);
    opacity: 0;
  }
  100% {
    transform: translateX(-200px);
    opacity: 0;
  }
}
@keyframes dotsAnim {
  0% {
    opacity: 0.3;
  }
  10% {
    opacity: 0.3;
  }
  20% {
    opacity: 1;
  }
  30% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0%;
  max-width: 100vw;
  margin: 0 auto;
  overflow-x: hidden;
}
.home .home__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  margin-left: 5%;
  gap: 2vw;
}
.home .home__row .home_row_column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  min-width: 0;
  justify-content: center;
}
.home .home__row .home_row_column h1 {
  text-align: left;
  font-size: clamp(2rem, 4vw, 3.9rem);
  line-height: 1.2;
  margin-bottom: 1.5rem;
  font-weight: 700;
  word-spacing: normal;
  overflow-wrap: break-word;
  hyphens: auto;
}
.home .home__row .home_row_column span {
  color: #f04923;
}
.home .home__row .home_row_column h5 {
  font-size: clamp(1.1rem, 1.8vw, 1.8rem);
  font-weight: 400;
  margin: 0 0 2rem;
  color: #555;
}
.home .home__row .home_row_column .find__btn {
  background-color: #e63b11;
  color: #fff;
  height: clamp(3rem, 4vw, 4rem);
  border-radius: 2rem;
  border: none;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(100%, 350px);
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.05rem;
  padding: 0 1.2rem;
  transition: all 0.3s ease;
  gap: 1.2rem;
  font-size: clamp(0.8rem, 1vw, 1rem);
}
.home .home__row .home_row_column .find__btn:hover {
  background-color: #000;
  transform: translateY(-2px);
}
.home .home__row .home_row_column .find__btn .find_btn_icon {
  font-size: clamp(1.2rem, 1.8vw, 1.8rem);
}
.home .home__row .home_row_column a {
  display: inline-flex;
  align-items: center;
  margin-top: 1.5rem;
  cursor: pointer;
  text-decoration: none;
  color: #000;
  transition: all 0.3s ease;
  font-size: clamp(0.9rem, 1.2vw, 1.2rem);
  gap: 0.5rem;
}
.home .home__row .home_row_column a .row_text_icon {
  color: #e63b11;
  font-size: clamp(1.2rem, 1.8vw, 1.8rem);
  transition: all 0.3s ease;
  margin-left: 1rem;
}
.home .home__row .home_row_column a:hover {
  text-decoration: underline;
  text-underline-offset: 0.3rem;
}
.home .home__row .home_row_column a:hover .row_text_icon {
  color: #000;
  transform: scale(1.1);
}
.home .home__row img {
  width: 60%;
  object-fit: contain;
}
@media (max-width: 1024px) {
  .home .home__row {
    gap: 3rem;
  }
  .home .home__row .home_row_column h1 {
    font-size: clamp(1.8rem, 3.2vw, 2.5rem);
  }
  .home .home__row .home_row_column h5 {
    margin-bottom: 1.5rem;
  }
}
@media (max-width: 768px) {
  .home .home__row {
    flex-direction: column;
    gap: 2rem;
    padding: 0 0%;
  }
  .home .home__row .home_row_column {
    align-items: center;
    text-align: center;
    width: 100%;
  }
  .home .home__row .home_row_column h1 {
    text-align: center;
    font-size: clamp(1.6rem, 5vw, 2.2rem);
  }
  .home .home__row .home_row_column h5 {
    text-align: center;
    font-size: clamp(1rem, 3.5vw, 1.4rem);
  }
  .home .home__row .home_row_column .find__btn {
    width: 100%;
    max-width: 280px;
  }
  .home .home__row img {
    width: 100%;
    margin: 0 auto;
  }
}
@media (max-width: 480px) {
  .home .home__row {
    padding: 0 0%;
    margin-left: 0%;
  }
  .home .home__row .home_row_column h1 {
    font-size: clamp(1.4rem, 6vw, 1.8rem);
    line-height: 1.3;
  }
  .home .home__row .home_row_column .find__btn {
    height: 2.8rem;
    font-size: 0.75rem;
  }
}
.home .home__banner {
  background-color: #e63b11;
  color: #fff;
  width: 100vw;
  align-items: center;
  text-align: center;
}
.home .home__banner p {
  font-size: 2rem;
  font-weight: 700;
}
@media (min-width: 1440px) and (max-width: 1900px) {
  .home .home__banner {
    margin-top: -0.5%;
    width: 100vw;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .home .home__banner p {
    font-size: 1.5rem;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .home .home__banner {
    margin-top: -1%;
  }
  .home .home__banner p {
    font-size: 1.8rem;
  }
}
@media (max-width: 690px) {
  .home .home__banner {
    width: 100vw;
  }
  .home .home__banner p {
    font-size: 1.2rem;
  }
}
.home .home__why {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80vw;
  margin: 0 auto;
}
.home .home__why h2 {
  font-size: 3rem;
}
.home .home__why h2 span {
  color: #e63b11;
}
.home .home__why .home_why_row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 1.15rem;
  margin-bottom: 2%;
  flex-wrap: wrap;
}
.home .home__why .home_why_row .why_reason {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 30%;
  text-align: center;
  margin-bottom: 3%;
}
.home .home__why .home_why_row .why_reason img,
.home .home__why .home_why_row .why_reason .why_icon {
  height: 4rem;
  color: #e63b11;
  font-size: 4rem;
}
.home .home__why .home_why_row .why_reason p {
  text-align: center;
  width: 100%;
  padding: 0% 5%;
}
.home .home__why .home_why_row .why_reason p span {
  color: #e63b11;
}
@media (min-width: 1440px) and (max-width: 1900px) {
  .home .home__why .home_why_row {
    font-size: 1.1rem;
  }
  .home .home__why .home_why_row .why_reason img,
  .home .home__why .home_why_row .why_reason .why_icon {
    height: 3.5rem;
    font-size: 3.5rem;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .home .home__why {
    width: 90vw;
  }
  .home .home__why h2 {
    font-size: 2rem;
  }
  .home .home__why .home_why_row {
    font-size: 1rem;
  }
  .home .home__why .home_why_row .why_reason img,
  .home .home__why .home_why_row .why_reason .why_icon {
    height: 3rem;
    font-size: 3rem;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .home .home__why h2 {
    font-size: 2.3rem;
  }
  .home .home__why .home_why_row {
    font-size: 1rem;
  }
  .home .home__why .home_why_row .why_reason img,
  .home .home__why .home_why_row .why_reason .why_icon {
    height: 3.5rem;
    font-size: 3.5rem;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  .home .home__why h2 {
    font-size: 2.3rem;
  }
  .home .home__why .home_why_row {
    font-size: 1rem;
  }
  .home .home__why .home_why_row .why_reason img,
  .home .home__why .home_why_row .why_reason .why_icon {
    height: 3.5rem;
    font-size: 3.5rem;
  }
}
@media (max-width: 690px) {
  .home .home__why h2 {
    font-size: 1.8rem;
  }
  .home .home__why .home_why_row {
    font-size: 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0%;
  }
  .home .home__why .home_why_row .why_reason {
    flex: 150px 1;
    margin-bottom: 5%;
  }
  .home .home__why .home_why_row .why_reason strong {
    font-size: 1.2rem;
  }
  .home .home__why .home_why_row .why_reason img,
  .home .home__why .home_why_row .why_reason .why_icon {
    height: 2.5rem;
    font-size: 2rem;
    margin-bottom: 20px;
  }
  .home .home__why .home_why_row .why_reason p {
    font-size: 0.9rem;
    word-wrap: break-word;
    /* Breaks long words if needed */
  }
}
.home .home__pricing1 {
  position: relative;
  width: 100vw;
}
.home .home__pricing1 .img_container {
  position: absolute;
  z-index: 0;
  opacity: 0.2;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  overflow: hidden;
}
.home .home__pricing1 .home_pricing_content {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.home .home__pricing1 .home_pricing_content h2 {
  font-size: 3rem;
}
.home .home__pricing1 .home_pricing_content h2 span {
  color: #e63b11;
}
.home .home__pricing1 .home_pricing_content .pricing_row {
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 100%;
}
.home .home__pricing1 .home_pricing_content .pricing_row .pricing_card {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2% 0;
  width: 25vw;
  height: 52vh;
}
.home .home__pricing1 .home_pricing_content .pricing_row .pricing_card h2 {
  text-transform: uppercase;
  font-size: 2rem;
}
.home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card_icon {
  font-size: 5rem;
  color: #e63b11;
}
.home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .img_icon {
  position: relative;
  height: 5rem;
  width: auto;
  opacity: 1;
}
.home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card__text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: 30%;
}
.home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card__text strong {
  font-size: 1.2rem;
  margin-bottom: 2%;
}
.home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card__text strong span {
  color: #e63b11;
}
.home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .line_big {
  border-bottom: 2px solid #e63b11;
  width: 30%;
  align-self: flex-start;
  margin-top: 10%;
}
.home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .line_small {
  border-bottom: 2px solid #e63b11;
  width: 20%;
  align-self: flex-start;
  margin-top: 3%;
}
.home .home__pricing1 .home_pricing_content .pricing_row .pricing_card em {
  width: 60%;
  text-align: center;
  margin-top: 10%;
}
.home .home__pricing1 .home_pricing_content .pricing_content_dots {
  display: none;
}
@media (min-width: 1440px) and (max-width: 1900px) {
  .home .home__pricing1 .img_container {
    height: 83vh;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 62vh;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .card__text {
    height: 40%;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row em {
    margin-top: 12%;
  }
  .home .home__pricing1 .home_pricing_content .pricing_content_dots {
    display: none;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .home .home__pricing1 .img_container {
    height: 52vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .home .home__pricing1 .home_pricing_content h2 {
    font-size: 2rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card {
    height: 38vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card h2 {
    font-size: 1.5rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card_icon {
    font-size: 4rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .img_icon {
    height: 4rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card__text {
    height: 15%;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card__text strong {
    font-size: 1rem;
    width: 90%;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card em {
    width: 80%;
    text-align: center;
    margin-top: 10%;
  }
  .home .home__pricing1 .home_pricing_content .pricing_content_dots {
    display: none;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .home .home__pricing1 .img_container {
    height: 72vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .home .home__pricing1 .home_pricing_content h2 {
    font-size: 2.3rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card h2 {
    font-size: 1.8rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card__text strong {
    font-size: 1rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card em {
    width: 80%;
    margin-top: 10%;
  }
  .home .home__pricing1 .home_pricing_content .pricing_content_dots {
    display: none;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  .home .home__pricing1 .img_container {
    height: 85vh;
  }
  .home .home__pricing1 .home_pricing_content h2 {
    font-size: 2.3rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 61vh;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card h2 {
    font-size: 1.8rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card_icon {
    font-size: 3rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .img_icon {
    height: 3rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card__text {
    height: 15%;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card__text strong {
    font-size: 1rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card em {
    font-size: 0.9rem;
  }
}
@media (max-width: 690px) {
  .home .home__pricing1 .img_container {
    height: 68vh;
  }
  .home .home__pricing1 .home_pricing_content h2 {
    font-size: 1.8rem;
    text-align: center;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row {
    position: relative;
    width: 100%;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card {
    position: absolute;
    left: 10%;
    width: 80%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    opacity: 0;
    padding-bottom: 20px;
    animation: display 15s infinite;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card h2 {
    font-size: 1.6rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card_icon {
    font-size: 3rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .img_icon {
    height: 3rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card__text {
    height: 15%;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card .card__text strong {
    font-size: 1rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card em {
    width: 90%;
    text-align: center;
    margin-top: 10%;
    font-size: 0.9rem;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card:nth-child(2) {
    animation-delay: 5s;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card:nth-child(3) {
    animation-delay: 10s;
  }
  .home .home__pricing1 .home_pricing_content .pricing_content_dots {
    display: flex;
    position: absolute;
    top: 550px;
  }
  .home .home__pricing1 .home_pricing_content .pricing_content_dots .content_dot {
    opacity: 0.3;
    animation: dotsAnim 5s infinite;
  }
  .home .home__pricing1 .home_pricing_content .pricing_content_dots .content_dot:nth-child(2) {
    animation-delay: 5s;
  }
  .home .home__pricing1 .home_pricing_content .pricing_content_dots .content_dot:nth-child(3) {
    animation-delay: 10s;
  }
}
@media (min-width: 2000px) {
  .home .home__pricing1 .img_container {
    height: 85vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .home .home__pricing1 .home_pricing_content .pricing_row .pricing_card {
    height: 45vh;
    width: 18vw;
  }
}
.home .home__pricing2 {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.home .home__pricing2 .img_container {
  position: absolute;
  z-index: 0;
  opacity: 0.2;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.home .home__pricing2 .img_container img {
  width: 10%;
  height: 10%;
}
.home .home__pricing2 .home_pricing_content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
}
.home .home__pricing2 .home_pricing_content h2 {
  font-size: clamp(2rem, 3.5vw, 3.5rem);
  text-align: center;
  margin-bottom: 3rem;
}
.home .home__pricing2 .home_pricing_content h2 span {
  color: #e63b11;
}
.home .home__pricing2 .home_pricing_content .pricing_row {
  position: relative;
  width: 100%;
  min-height: 52vh;
}
@media (max-width: 690px) {
  .home .home__pricing2 .home_pricing_content .pricing_row {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    scrollbar-width: none;
  }
  .home .home__pricing2 .home_pricing_content .pricing_row .img_container {
    height: 68vh;
  }
  .home .home__pricing2 .home_pricing_content .pricing_row::-webkit-scrollbar {
    display: none;
  }
}
.home .home__pricing2 .home_pricing_content .pricing_row .pricing_card {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  width: clamp(250px, 25vw, 350px);
  height: 52vh;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
@media (max-width: 690px) {
  .home .home__pricing2 .home_pricing_content .pricing_row .pricing_card {
    flex: 0 0 80%;
    scroll-snap-align: center;
    margin: 0 10%;
    height: auto;
    min-height: 400px;
    opacity: 0;
  }
  .home .home__pricing2 .home_pricing_content .pricing_row .pricing_card:nth-child(1) {
    animation: fadeInOut 15s infinite 0s;
  }
  .home .home__pricing2 .home_pricing_content .pricing_row .pricing_card:nth-child(2) {
    animation: fadeInOut 15s infinite 5s;
  }
  .home .home__pricing2 .home_pricing_content .pricing_row .pricing_card:nth-child(3) {
    animation: fadeInOut 15s infinite 10s;
  }
  .home .home__pricing2 .home_pricing_content .pricing_row .pricing_card.active {
    opacity: 1;
    animation: none;
  }
}
.home .home__pricing2 .home_pricing_content .pricing_content_dots {
  display: flex;
  position: absolute;
  top: 550px;
}
.home .home__pricing2 .home_pricing_content .pricing_content_dots .content_dot {
  opacity: 0.3;
  animation: dotsAnim 5s infinite;
}
.home .home__pricing2 .home_pricing_content .pricing_content_dots .content_dot:nth-child(2) {
  animation-delay: 5s;
}
.home .home__pricing2 .home_pricing_content .pricing_content_dots .content_dot:nth-child(3) {
  animation-delay: 10s;
}
@keyframes fadeInOut {
  0%, 20% {
    opacity: 0;
    transform: translateX(-20px);
  }
  5%, 15% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(20px);
  }
}
.home .home__how {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.home .home__how h2 {
  font-size: 3rem;
}
.home .home__how h2 span {
  color: #e63b11;
}
.home .home__how .home_how_cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5%;
  width: 100%;
  max-width: 1700px;
  padding: 0 15px;
}
.home .home__how .home_how_cards .home_how_card {
  width: 100%;
  min-height: 35vh;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10%;
  box-sizing: border-box;
}
.home .home__how .home_how_cards .home_how_card .how_card_icon {
  font-size: 3.5rem;
  margin-bottom: 15px;
}
.home .home__how .home_how_cards .home_how_card .how_card_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
}
.home .home__how .home_how_cards .home_how_card h3 {
  color: #e63b11;
  text-transform: uppercase;
  font-size: 1.8rem;
  margin: 10px 0;
  text-align: center;
}
.home .home__how .home_how_cards .home_how_card p {
  width: 80%;
  text-align: center;
}
.home .home__how button {
  background-color: #e63b11;
  color: #fff;
  text-transform: uppercase;
  border: none;
  border-radius: 1.5rem;
  letter-spacing: 0.1rem;
  font-weight: 600;
  transition: background-color 0.3s ease;
  padding: 0 2rem;
  cursor: pointer;
  height: 2.5rem;
  margin: 3% auto;
}
.home .home__how button:hover {
  background-color: #000;
}
@media (max-width: 850px) {
  .home .home__how h2 {
    font-size: 2rem;
  }
  .home .home__how .home_how_cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 4%;
  }
  .home .home__how .home_how_cards .home_how_card .how_card_icon {
    font-size: 3rem;
  }
  .home .home__how .home_how_cards .home_how_card h3 {
    font-size: 1.5rem;
  }
}
@media (max-width: 690px) {
  .home .home__how h2 {
    font-size: 1.8rem;
  }
  .home .home__how button {
    margin: 10% 0%;
  }
  .home .home__how .home_how_cards {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 2%;
    column-gap: 4%;
  }
  .home .home__how .home_how_cards .home_how_card {
    min-height: 25vh;
    padding: 30px 5px;
    justify-items: flex-start;
  }
  .home .home__how .home_how_cards .home_how_card .how_card_icon {
    font-size: 2.5rem;
    align-items: flex-start;
  }
  .home .home__how .home_how_cards .home_how_card h3 {
    font-size: 1.2rem;
  }
  .home .home__how .home_how_cards .home_how_card p {
    font-size: 0.9rem;
  }
}
.home .home__app {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100vw;
  background-color: #f2f2f2;
}
.home .home__app .home_app_text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 30%;
}
.home .home__app .home_app_text h2 {
  font-size: 3rem;
}
.home .home__app .home_app_text h2 span {
  color: #e63b11;
}
.home .home__app .home_app_text h6 {
  font-size: 1.2rem;
  font-weight: 400;
}
.home .home__app .home_app_text strong {
  font-size: 2rem;
}
.home .home__app .home_app_text .text_row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 75%;
  margin: 5% 0;
}
.home .home__app .home_app_text .text_row a img {
  width: 90%;
}
.home .home__app .home_app_text .text_row a img:first-child {
  margin-right: 10%;
}
.home .home__app img {
  width: 15%;
}
@media (min-width: 1440px) and (max-width: 1900px) {
  .home .home__app {
    width: 98.5vw;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .home .home__app {
    width: 99vw;
  }
  .home .home__app .home_app_text h2 {
    font-size: 2rem;
  }
  .home .home__app .home_app_text h6 {
    font-size: 1rem;
  }
  .home .home__app .home_app_text .text_row a img {
    width: 80%;
  }
  .home .home__app img {
    width: 20%;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .home .home__app .home_app_text h2 {
    font-size: 2.3rem;
  }
  .home .home__app .home_app_text h6 {
    font-size: 1.2rem;
  }
  .home .home__app .home_app_text .text_row a img {
    width: 70%;
  }
  .home .home__app img {
    width: 16%;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  .home .home__app .home_app_text h2 {
    font-size: 2.3rem;
  }
  .home .home__app .home_app_text h6 {
    font-size: 1.2rem;
  }
  .home .home__app .home_app_text .text_row a img {
    width: 70%;
  }
  .home .home__app img {
    width: 16%;
  }
}
@media (max-width: 690px) {
  .home .home__app {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 99vw;
  }
  .home .home__app .home_app_text {
    width: 90%;
  }
  .home .home__app .home_app_text h2 {
    font-size: 1.8rem;
    align-self: center;
  }
  .home .home__app .home_app_text h6 {
    font-size: 1rem;
    margin-top: 0;
    text-align: center;
  }
  .home .home__app .home_app_text strong {
    align-self: center;
    margin-top: 0;
    font-size: 1.2rem;
  }
  .home .home__app .home_app_text .text_row {
    align-self: center;
    justify-content: center;
  }
  .home .home__app .home_app_text .text_row a {
    margin-left: 10%;
  }
  .home .home__app .home_app_text .text_row a img {
    width: 95%;
  }
  .home .home__app #get_app_image {
    display: none;
  }
}
.home .home_laundry {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 2% 0%;
}
.home .home_laundry h2 {
  font-size: 3rem;
  width: 25%;
  text-align: center;
}
.home .home_laundry h2 span {
  color: #e63b11;
}
.home .home_laundry .home_laundry_text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 30%;
  text-align: center;
}
.home .home_laundry .home_laundry_text h3 {
  text-transform: uppercase;
  font-size: 2rem;
  margin: 1% auto;
}
.home .home_laundry .home_laundry_text h3 span {
  color: #e63b11;
}
.home .home_laundry .home_laundry_text p {
  margin: 0 auto 3% auto;
}
@media (min-width: 691px) and (max-width: 850px) {
  .home .home_laundry h2 {
    font-size: 2rem;
  }
  .home .home_laundry .home_laundry_text {
    width: 35%;
  }
  .home .home_laundry .home_laundry_text h3 {
    font-size: 1.3rem;
  }
  .home .home_laundry .home_laundry_text p {
    font-size: 0.9rem;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .home .home_laundry h2 {
    font-size: 2.3rem;
  }
  .home .home_laundry .home_laundry_text h3 {
    font-size: 1.8rem;
  }
  .home .home_laundry .home_laundry_text p {
    font-size: 0.9rem;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  .home .home_laundry h2 {
    font-size: 2.3rem;
  }
  .home .home_laundry .home_laundry_text h3 {
    font-size: 1.8rem;
  }
  .home .home_laundry .home_laundry_text p {
    font-size: 0.9rem;
  }
}
@media (max-width: 690px) {
  .home .home_laundry {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 99vw;
  }
  .home .home_laundry h2 {
    font-size: 1.8rem;
    text-align: center;
    width: 90%;
  }
  .home .home_laundry .home_laundry_text {
    width: 95%;
  }
  .home .home_laundry .home_laundry_text h3 {
    font-size: 1.2rem;
  }
  .home .home_laundry .home_laundry_text p {
    font-size: 0.9rem;
  }
}
.home .home__contact {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #f2f2f2;
  padding: 2rem 0;
}
.home .home__contact .home_contact_text {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-items: center;
  padding: 0 2rem;
}
.home .home__contact .home_contact_text h2 {
  font-size: clamp(1.8rem, 3vw, 3rem);
  text-align: center;
  margin-bottom: 1rem;
}
.home .home__contact .home_contact_text h2 span {
  color: #e63b11;
}
.home .home__contact .home_contact_text p {
  font-size: clamp(1rem, 1.5vw, 2rem);
  width: 80%;
  text-align: center;
  margin: 0;
}
.home .home__contact .home_contact_form {
  width: 50%;
  padding: 0 2rem;
}
.home .home__contact .home_contact_form .form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  max-width: 500px;
}
.home .home__contact .home_contact_form .form h3 {
  font-size: clamp(1.3rem, 1.8vw, 2rem);
  margin-bottom: 1.5rem;
}
.home .home__contact .home_contact_form .form .contact_names {
  display: flex;
  gap: 2rem;
  width: 100%;
  margin-bottom: 1rem;
}
.home .home__contact .home_contact_form .form .contact_names .form_column {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.home .home__contact .home_contact_form .form .contact_names .form_column input {
  width: 100%;
  background-color: transparent;
  border: none;
  border-bottom: 2px solid #000;
  height: 2.8rem;
  padding: 0.5rem 0;
  font-size: 1.2rem;
}
.home .home__contact .home_contact_form .form .contact_names .form_column input:focus {
  outline: none;
  border-bottom: 2px solid #e63b11;
}
.home .home__contact .home_contact_form .form .form__field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 1.5rem;
}
.home .home__contact .home_contact_form .form .form__field input,
.home .home__contact .home_contact_form .form .form__field textarea {
  width: 100%;
  background-color: transparent;
  border: none;
  border-bottom: 2px solid #000;
  padding: 0.5rem 0;
}
.home .home__contact .home_contact_form .form .form__field input:focus,
.home .home__contact .home_contact_form .form .form__field textarea:focus {
  outline: none;
  border-bottom: 2px solid #e63b11;
}
.home .home__contact .home_contact_form .form .form__field textarea {
  height: 6rem;
  resize: vertical;
}
.home .home__contact .home_contact_form .form button {
  background-color: #e63b11;
  color: #fff;
  text-transform: uppercase;
  border: none;
  border-radius: 1.5rem;
  letter-spacing: 0.1rem;
  font-weight: 600;
  transition: background-color 0.3s ease;
  padding: 0 2rem;
  cursor: pointer;
  width: 100%;
  max-width: 200px;
  height: 2.5rem;
  margin: 1rem auto 0;
}
.home .home__contact .home_contact_form .form button:hover {
  background-color: #000;
}
@media (max-width: 690px) {
  .home .home__contact {
    flex-direction: column;
  }
  .home .home__contact .home_contact_text,
  .home .home__contact .home_contact_form {
    width: 100%;
    padding: 1rem;
  }
  .home .home__contact .home_contact_form .form {
    max-width: 100%;
  }
  .home .home__contact .home_contact_form .form .contact_names {
    flex-direction: row;
    gap: 1.5rem;
  }
  .home .home__contact .home_contact_form .form .contact_names .form_column {
    width: 100%;
  }
}
@media (max-width: 690px) {
  .home .home__contact .home_contact_text h2 {
    font-size: 1.8rem;
  }
  .home .home__contact .home_contact_text p {
    font-size: 1rem;
  }
  .home .home__contact .home_contact_form .form h3 {
    font-size: 1.5rem;
  }
  .home .home__contact .home_contact_form .form button {
    width: 100%;
    max-width: none;
  }
}

.investors__page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1%;
}
.investors__page .investors {
  width: 90%;
  margin: 2% auto;
  min-height: 53vh;
}
.investors__page .investors .investor_row {
  display: flex;
  align-items: center;
  justify-content: center;
}
.investors__page .investors .investor_row input {
  border: none;
  border-bottom: 2px solid #e63b11;
  margin-left: 1%;
}
.investors__page .investors .investor_row input:active, .investors__page .investors .investor_row input:focus, .investors__page .investors .investor_row input:hover {
  outline: none;
  border-bottom-color: #939598;
}
.investors__page .investors .investor_pack {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.investors__page .investors .investor_pack h1 {
  text-transform: uppercase;
}
.investors__page .investors .investor_pack .download__btn {
  display: flex;
  align-items: center;
  font-family: inherit;
  font-weight: 500;
  font-size: 17px;
  padding: 0.8em 1.5em 0.8em 1.2em;
  color: white;
  background: #e63b11;
  border: none;
  box-shadow: 0 0.7em 1.5em -0.5em #e63b11;
  letter-spacing: 0.05em;
  border-radius: 20em;
  margin-bottom: 2%;
}
.investors__page .investors .investor_pack .download__btn .btn_icon {
  margin-right: 8px;
}
.investors__page .investors .investor_pack .download__btn:hover {
  box-shadow: 0 0.5em 1.5em -0.5em #e63b11;
}
.investors__page .investors .investor_pack .download__btn:active {
  box-shadow: 0 0.3em 1em -0.5em #e63b11;
}
.investors__page .investors .investor_pack img {
  width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/home.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE;IACE,4BAAA;IACA,UAAA;EADF;EAIA;IACE,wBAAA;IACA,UAAA;EAFF;EAKA;IACE,wBAAA;IACA,UAAA;EAHF;EAMA;IACE,6BAAA;IACA,UAAA;EAJF;EAOA;IACE,6BAAA;IACA,UAAA;EALF;AACF;AAQA;EACE;IACE,YAAA;EANF;EASA;IACE,YAAA;EAPF;EAUA;IACE,UAAA;EARF;EAWA;IACE,UAAA;EATF;EAYA;IACE,YAAA;EAVF;AACF;AAaA;ECZI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDWF,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AARF;AAUE;ECOE,aAAA;EACA,mBAAA;EACA,8BAAA;EDPA,cAAA;EAGA,eAAA;EACA,QAAA;AARJ;AAUI;ECpBA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EDmBE,uBAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;AALN;AAOM;EACE,gBAAA;EACA,mCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EAGA,yBAAA;EACA,aAAA;AAPR;AAUM;EACE,cAAA;AARR;AAWM;EACE,uCAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AATR;AAYM;EACE,yBCjGC;EDkGD,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,mCAAA;AAVR;AAYQ;EACE,sBAAA;EACA,2BAAA;AAVV;AAaQ;EACE,uCAAA;AAXV;AAeM;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,yBAAA;EACA,uCAAA;EACA,WAAA;AAbR;AAeQ;EACE,cCzID;ED0IC,uCAAA;EACA,yBAAA;EACA,iBAAA;AAbV;AAgBQ;EACE,0BAAA;EACA,6BAAA;AAdV;AAgBU;EACE,WAAA;EACA,qBAAA;AAdZ;AAoBI;EAEE,UAAA;EACA,mBAAA;AAnBN;AAuBI;EAzGF;IA0GI,SAAA;EApBJ;EAuBM;IACE,uCAAA;EArBR;EAwBM;IACE,qBAAA;EAtBR;AACF;AA0BI;EAvHF;IAwHI,sBAAA;IACA,SAAA;IACA,aAAA;EAvBJ;EAyBI;IACE,mBAAA;IACA,kBAAA;IACA,WAAA;EAvBN;EAyBM;IACE,kBAAA;IACA,qCAAA;EAvBR;EA0BM;IACE,kBAAA;IACA,qCAAA;EAxBR;EA2BM;IACE,WAAA;IACA,gBAAA;EAzBR;EA6BI;IACE,WAAA;IAEA,cAAA;EA5BN;AACF;AAgCI;EAzJF;IA2JI,aAAA;IACA,eAAA;EA9BJ;EAgCM;IACE,qCAAA;IACA,gBAAA;EA9BR;EAiCM;IACE,cAAA;IACA,kBAAA;EA/BR;AACF;AAoCE;EACE,yBCrOK;EDsOL,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAlCJ;AAoCI;EACE,eAAA;EACA,gBAAA;AAlCN;AAqCI;EAZF;IAaI,iBAAA;IACA,YAAA;EAlCJ;AACF;AAoCI;EACE;IACE,iBAAA;EAlCN;AACF;AAqCI;EAvBF;IAwBI,eAAA;EAlCJ;EAoCI;IACE,iBAAA;EAlCN;AACF;AAqCI;EA/BF;IAgCI,YAAA;EAlCJ;EAoCI;IAEE,iBAAA;EAnCN;AACF;AAuCE;ECvOE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDsOA,WAAA;EACA,cAAA;AAlCJ;AAoCI;EACE,eAAA;AAlCN;AAoCM;EACE,cCtRC;ADoPT;AAsCI;ECpNA,aAAA;EACA,uBAAA;EACA,8BAAA;EDoNE,kBAAA;EACA,iBAAA;EACA,eAAA;AAlCN;AAoCM;EC1PF,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDyPI,UAAA;EACA,kBAAA;EACA,iBAAA;AA/BR;AAiCQ;;EAEE,YAAA;EACA,cCzSD;ED0SC,eAAA;AA/BV;AAkCQ;EACE,kBAAA;EACA,WAAA;EAEA,cAAA;AAjCV;AAmCU;EACE,cCpTH;ADmRT;AAsCM;EA/BF;IAgCI,iBAAA;EAnCN;EAuCQ;;IAEE,cAAA;IACA,iBAAA;EArCV;AACF;AA0CI;EA1DF;IA2DI,WAAA;EAvCJ;EAyCI;IACE,eAAA;EAvCN;EA0CI;IACE,eAAA;EAxCN;EA4CQ;;IAEE,YAAA;IACA,eAAA;EA1CV;AACF;AA+CI;EACE;IACE,iBAAA;EA7CN;EAgDI;IACE,eAAA;EA9CN;EAkDQ;;IAEE,cAAA;IACA,iBAAA;EAhDV;AACF;AAqDI;EACE;IACE,iBAAA;EAnDN;EAsDI;IACE,eAAA;EApDN;EAwDQ;;IAEE,cAAA;IACA,iBAAA;EAtDV;AACF;AA2DI;EACE;IACE,iBAAA;EAzDN;EA4DI;IACE,eAAA;IACA,WAAA;IACA,aAAA;IACA,uBAAA;IACA,WAAA;EA1DN;EA4DM;IACE,aAAA;IACA,iBAAA;EA1DR;EA4DQ;IACE,iBAAA;EA1DV;EA6DQ;;IAEE,cAAA;IACA,eAAA;IACA,mBAAA;EA3DV;EA8DQ;IACE,iBAAA;IAMA,qBAAA;IACA,gCAAA;EAjEV;AACF;AA0EE;EACE,kBAAA;EACA,YAAA;AAxEJ;AA0EI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAzEN;AA4EI;EACE,kBAAA;EACA,UAAA;EC3ZF,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;ED0ZE,WAAA;AAvEN;AAyEM;EACE,eAAA;AAvER;AAyEQ;EACE,cCzcD;ADkYT;AA2EM;ECnZF,aAAA;EACA,uBAAA;EACA,6BAAA;EDmZI,WAAA;AAvER;AAyEQ;EACE,sBAAA;EC5aN,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;ED2aM,aAAA;EACA,WAAA;EACA,YAAA;AApEV;AAsEU;EACE,yBAAA;EACA,eAAA;AApEZ;AAuEU;EACE,eAAA;EACA,cC/dH;AD0ZT;AAwEU;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAtEZ;AAyEU;ECncN,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDmcQ,eAAA;AArEZ;AAuEY;EACE,iBAAA;EACA,iBAAA;AArEd;AAuEc;EACE,cCnfP;AD8aT;AA0EU;EACE,gCAAA;EACA,UAAA;EACA,sBAAA;EACA,eAAA;AAxEZ;AA2EU;EACE,gCAAA;EACA,UAAA;EACA,sBAAA;EACA,cAAA;AAzEZ;AA4EU;EACE,UAAA;EACA,kBAAA;EACA,eAAA;AA1EZ;AA+EM;EACE,aAAA;AA7ER;AAiFI;EACE;IAEE,YAAA;EAhFN;EAqFQ;IC5fN,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,2BAAA;ID2fQ,YAAA;EAhFV;EAmFQ;IACE,WAAA;EAjFV;EAoFQ;IACE,eAAA;EAlFV;EAsFM;IACE,aAAA;EApFR;AACF;AAwFI;EACE;IACE,YAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EAtFN;EA0FM;IACE,eAAA;EAxFR;EA4FQ;IACE,YAAA;IC/hBR,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,2BAAA;EDscF;EAyFU;IACE,iBAAA;EAvFZ;EA0FU;IACE,eAAA;EAxFZ;EA2FU;IACE,YAAA;EAzFZ;EA4FU;IACE,WAAA;EA1FZ;EA4FY;IACE,eAAA;IACA,UAAA;EA1Fd;EA8FU;IACE,UAAA;IACA,kBAAA;IACA,eAAA;EA5FZ;EAiGM;IACE,aAAA;EA/FR;AACF;AAmGI;EACE;IACE,YAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EAjGN;EAqGM;IACE,iBAAA;EAnGR;EAuGQ;ICnlBN,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,2BAAA;ED+eF;EAoGU;IACE,iBAAA;EAlGZ;EAsGY;IACE,eAAA;EApGd;EAwGU;IACE,UAAA;IACA,eAAA;EAtGZ;EA2GM;IACE,aAAA;EAzGR;AACF;AA6GI;EACE;IACE,YAAA;EA3GN;EA+GM;IACE,iBAAA;EA7GR;EAiHQ;ICxnBN,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,2BAAA;IDunBQ,YAAA;EA5GV;EA8GU;IACE,iBAAA;EA5GZ;EA+GU;IACE,eAAA;EA7GZ;EAgHU;IACE,YAAA;EA9GZ;EAiHU;IACE,WAAA;EA/GZ;EAiHY;IACE,eAAA;EA/Gd;EAmHU;IACE,iBAAA;EAjHZ;AACF;AAuHI;EACE;IACE,YAAA;EArHN;EA0HM;IACE,iBAAA;IACA,kBAAA;EAxHR;EA2HM;IACE,kBAAA;IACA,WAAA;EAzHR;EA2HQ;IACE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,YAAA;IC5qBR,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,2BAAA;ID2qBQ,UAAA;IACA,oBAAA;IACA,+BAAA;EAtHV;EAwHU;IACE,iBAAA;EAtHZ;EAyHU;IACE,eAAA;EAvHZ;EA0HU;IACE,YAAA;EAxHZ;EA2HU;IACE,WAAA;EAzHZ;EA2HY;IACE,eAAA;EAzHd;EA6HU;IACE,UAAA;IACA,kBAAA;IACA,eAAA;IACA,iBAAA;EA3HZ;EA8HU;IACE,mBAAA;EA5HZ;EA+HU;IACE,oBAAA;EA7HZ;EAkIM;IACE,aAAA;IACA,kBAAA;IAEA,UAAA;EAjIR;EAmIQ;IACE,YAAA;IACA,+BAAA;EAjIV;EAmIU;IACE,mBAAA;EAjIZ;EAoIU;IACE,oBAAA;EAlIZ;AACF;AAwII;EACE;IACE,YAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EAtIN;EA2IQ;IACE,YAAA;IACA,WAAA;EAzIV;AACF;AAodA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAldF;AAodE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAndJ;AAqdI;EACE,UAAA;EACA,WAAA;AAndN;AAwdE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAtdJ;AAydI;EACE,qCAAA;EACA,kBAAA;EACA,mBAAA;AAvdN;AAydM;EACE,cC1oCC;ADmrBT;AA2dI;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAzdN;AA2dM;EALF;IAUI,aAAA;IACA,gBAAA;IACA,6BAAA;IACA,iCAAA;IACA,uBAAA;IACA,qBAAA;EA5dN;EAmdM;IACQ,YAAA;EAjdd;EA0dM;IACE,aAAA;EAxdR;AACF;AA2dM;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;EACA,qBAAA;EACA,yCAAA;EACA,yBAAA;AAzdR;AA2dQ;EAZF;IAaI,aAAA;IACA,yBAAA;IACA,aAAA;IACA,YAAA;IACA,iBAAA;IACA,UAAA;EAxdR;EA0dQ;IACE,oCAAA;EAxdV;EA0dQ;IACE,oCAAA;EAxdV;EA0dQ;IACE,qCAAA;EAxdV;EA2dQ;IACE,UAAA;IACA,eAAA;EAzdV;AACF;AAgeI;EACE,aAAA;EACI,kBAAA;EAEA,UAAA;AA/dV;AAieU;EACE,YAAA;EACA,+BAAA;AA/dZ;AAieY;EACE,mBAAA;AA/dd;AAkeY;EACE,oBAAA;AAhed;AAueA;EACE;IAAU,UAAA;IAAY,4BAAA;EAnetB;EAoeA;IAAU,UAAA;IAAY,wBAAA;EAhetB;EAieA;IAAO,UAAA;IAAY,2BAAA;EA7dnB;AACF;AA+dE;ECjsCE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;ADquBJ;AA6dI;EACE,eAAA;AA3dN;AA6dM;EACE,cC/uCC;ADoxBT;AA+dI;EACE,aAAA;EACA,qCAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EAEA,eAAA;AA9dN;AAgeM;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,YAAA;EACA,sBAAA;AA/dR;AAieQ;EACE,iBAAA;EACA,mBAAA;AA/dV;AAkeQ;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAheV;AAmeQ;EACE,cCrxCD;EDsxCC,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAjeV;AAoeQ;EACE,UAAA;EAEA,kBAAA;AAneV;AAweI;ECltCI,yBAlFC;EAmFD,WAAA;EACA,yBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sBAAA;EACA,gBAAA;EAEA,sCAAA;EACA,eAAA;EACA,eAAA;EDysCF,cAAA;EACA,eAAA;AA7dN;AC3uBQ;EACE,sBAAA;AD6uBV;AAkeI;EAGE;IACE,eAAA;EAleN;EAqeI;IACE,qCAAA;IACD,OAAA;EAneL;EAseQ;IACE,eAAA;EApeV;EAueQ;IACE,iBAAA;EAreV;AACF;AA0eI;EAGE;IACE,iBAAA;EA1eN;EA4eI;IACE,cAAA;EA1eN;EA4eI;IACE,qCAAA;IACA,WAAA;IACA,cAAA;EA1eN;EA2eM;IACE,gBAAA;IACA,iBAAA;IAEA,yBAAA;EA1eR;EA4eQ;IACE,iBAAA;IACA,uBAAA;EA1eV;EA6eQ;IACE,iBAAA;EA3eV;EA8eQ;IACE,iBAAA;EA5eV;AACF;AAsfE;EC1zCE,aAAA;EACA,mBAAA;EACA,6BAAA;ED0zCA,YAAA;EACA,yBAAA;AAlfJ;AAofI;EC31CA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ED01CE,UAAA;AA/eN;AAifM;EACE,eAAA;AA/eR;AAifQ;EACE,cC33CD;AD44BT;AAmfM;EACE,iBAAA;EACA,gBAAA;AAjfR;AAofM;EACE,eAAA;AAlfR;AAqfM;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,UAAA;EACA,YAAA;AAnfR;AAsfU;EACE,UAAA;AApfZ;AAsfY;EACE,iBAAA;AApfd;AA2fI;EACE,UAAA;AAzfN;AA4fI;EAjDF;IAkDI,aAAA;EAzfJ;AACF;AA2fI;EArDF;IAsDI,WAAA;EAxfJ;EA2fM;IACE,eAAA;EAzfR;EA4fM;IACE,eAAA;EA1fR;EA+fU;IACE,UAAA;EA7fZ;EAmgBI;IACE,UAAA;EAjgBN;AACF;AAogBI;EAEI;IACE,iBAAA;EAngBR;EAsgBM;IACE,iBAAA;EApgBR;EAygBU;IACE,UAAA;EAvgBZ;EA6gBI;IACE,UAAA;EA3gBN;AACF;AA8gBI;EAEI;IACE,iBAAA;EA7gBR;EAghBM;IACE,iBAAA;EA9gBR;EAmhBU;IACE,UAAA;EAjhBZ;EAuhBI;IACE,UAAA;EArhBN;AACF;AAwhBI;EA/HF;ICx0CE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IDs8CE,WAAA;EAlhBJ;EAohBI;IACE,UAAA;EAlhBN;EAohBM;IACE,iBAAA;IACA,kBAAA;EAlhBR;EAqhBM;IACE,eAAA;IACA,aAAA;IACA,kBAAA;EAnhBR;EAshBM;IACE,kBAAA;IACA,aAAA;IAEA,iBAAA;EArhBR;EAyhBM;IACE,kBAAA;IACA,uBAAA;EAvhBR;EAyhBQ;IACE,gBAAA;EAvhBV;EAyhBU;IACE,UAAA;EAvhBZ;EA6hBI;IACE,aAAA;EA3hBN;AACF;AA+hBE;ECv+CE,aAAA;EACA,mBAAA;EACA,6BAAA;EDu+CA,aAAA;AA3hBJ;AA6hBI;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AA3hBN;AA6hBM;EACE,cCriDC;AD0gCT;AA+hBI;ECngDA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDkgDE,UAAA;EACA,kBAAA;AA1hBN;AA4hBM;EACE,yBAAA;EACA,eAAA;EACA,eAAA;AA1hBR;AA4hBQ;EACE,cCpjDD;AD0hCT;AA8hBM;EACE,sBAAA;AA5hBR;AAgiBI;EACE;IACE,eAAA;EA9hBN;EAiiBI;IACE,UAAA;EA/hBN;EAiiBM;IACE,iBAAA;EA/hBR;EAkiBM;IACE,iBAAA;EAhiBR;AACF;AAoiBI;EACE;IACE,iBAAA;EAliBN;EAsiBM;IACE,iBAAA;EApiBR;EAuiBM;IACE,iBAAA;EAriBR;AACF;AAyiBI;EACE;IACE,iBAAA;EAviBN;EA2iBM;IACE,iBAAA;EAziBR;EA4iBM;IACE,iBAAA;EA1iBR;AACF;AA8iBI;EApFF;ICr/CE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IDwkDE,WAAA;EAxiBJ;EA0iBI;IACE,iBAAA;IACA,kBAAA;IACA,UAAA;EAxiBN;EA2iBI;IACE,UAAA;EAziBN;EA2iBM;IACE,iBAAA;EAziBR;EA4iBM;IACE,iBAAA;EA1iBR;AACF;AA+iBE;ECvkDE,aAAA;EACA,mBAAA;EACA,8BAAA;EDukDA,WAAA;EACA,yBAAA;EACA,eAAA;AA3iBJ;AA6iBI;EACE,UAAA;ECxmDF,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDumDE,mBAAA;EACA,eAAA;AAxiBN;AA0iBM;EACE,mCAAA;EACA,kBAAA;EACA,mBAAA;AAxiBR;AA0iBQ;EACE,cCzpDD;ADinCT;AA4iBM;EACE,mCAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AA1iBR;AA8iBI;EACE,UAAA;EACA,eAAA;AA5iBN;AA8iBM;ECjpDF,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EDgpDI,WAAA;EACA,gBAAA;AAziBR;AA2iBQ;EACE,qCAAA;EACA,qBAAA;AAziBV;AA4iBQ;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AA1iBV;AA4iBU;EACE,UAAA;EClqDR,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ADynCJ;AAyiBY;EACE,WAAA;EACA,6BAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAviBd;AAyiBc;EACE,aAAA;EACA,gCAAA;AAviBhB;AA6iBQ;ECtrDJ,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EDqrDM,WAAA;EACA,qBAAA;AAxiBV;AA0iBU;;EAEE,WAAA;EACA,6BAAA;EACA,YAAA;EACA,6BAAA;EACA,iBAAA;AAxiBZ;AA0iBY;;EACE,aAAA;EACA,gCAAA;AAviBd;AA2iBU;EACE,YAAA;EACA,gBAAA;AAziBZ;AA6iBQ;ECrpDA,yBAlFC;EAmFD,WAAA;EACA,yBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sBAAA;EACA,gBAAA;EAEA,sCAAA;EACA,eAAA;EACA,eAAA;ED4oDE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAliBV;AC3mCQ;EACE,sBAAA;AD6mCV;AAqiBI;EA3GF;IA4GI,sBAAA;EAliBJ;EAqiBI;;IAEE,WAAA;IACA,aAAA;EAniBN;EAuiBM;IACE,eAAA;EAriBR;EAuiBQ;IACE,mBAAA;IACA,WAAA;EAriBV;EAuiBU;IACE,WAAA;EAriBZ;AACF;AA2iBI;EAEI;IACE,iBAAA;EA1iBR;EA6iBM;IACE,eAAA;EA3iBR;EAijBQ;IACE,iBAAA;EA/iBV;EAkjBQ;IACE,WAAA;IACA,eAAA;EAhjBV;AACF;;AA2jBA;ECrwDI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDowDF,WAAA;AArjBF;AAujBE;EACE,UAAA;EACA,eAAA;EACA,gBAAA;AArjBJ;AAujBI;ECxuDA,aAAA;EACA,mBAAA;EACA,uBAAA;ADorCJ;AAqjBM;EACE,YAAA;EACA,gCAAA;EACA,eAAA;AAnjBR;AAqjBQ;EAGE,aAAA;EACA,4BC7zDC;ADwwCX;AA0jBI;EC/xDA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;ADwuCJ;AAujBM;EACE,yBAAA;AArjBR;AAwjBM;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,mBCp1DC;EDq1DD,YAAA;EACA,wCAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAtjBR;AAwjBQ;EACE,iBAAA;AAtjBV;AAyjBQ;EACE,wCAAA;AAvjBV;AA0jBQ;EACE,sCAAA;AAxjBV;AA4jBM;EACE,UAAA;AA1jBR","sourcesContent":["@import \"./variables.scss\";\n\n@keyframes display {\n  0% {\n    transform: translateX(200px);\n    opacity: 0;\n  }\n\n  10% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n\n  20% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n\n  30% {\n    transform: translateX(-200px);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateX(-200px);\n    opacity: 0;\n  }\n}\n\n@keyframes dotsAnim {\n  0% {\n    opacity: 0.3;\n  }\n\n  10% {\n    opacity: 0.3;\n  }\n\n  20% {\n    opacity: 1;\n  }\n\n  30% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0.3;\n  }\n}\n\n.home {\n  @include columnStack;\n  padding: 0%;\n  max-width: 100vw;\n  margin: 0 auto;\n  overflow-x: hidden;\n\n  .home__row {\n    @include rowBetween;\n    margin: 0 auto;\n    // max-width: 1400px;\n    // padding: 0 8%;\n    margin-left: 5%;\n    gap: 2vw;\n\n    .home_row_column {\n      @include columnCenter;\n      align-items: flex-start;\n      flex: 1;\n      min-width: 0; // Prevent text overflow\n      justify-content: center;\n\n      h1 {\n        text-align: left;\n        font-size: clamp(2rem, 4vw, 3.9rem);\n        line-height: 1.2;\n        margin-bottom: 1.5rem;\n        font-weight: 700;\n        word-spacing: normal;\n\n        // Break long text properly\n        overflow-wrap: break-word;\n        hyphens: auto;\n      }\n\n      span {\n        color: #f04923;\n      }\n\n      h5 {\n        font-size: clamp(1.1rem, 1.8vw, 1.8rem);\n        font-weight: 400;\n        margin: 0 0 2rem;\n        color: #555;\n      }\n\n      .find__btn {\n        background-color: $orange;\n        color: #fff;\n        height: clamp(3rem, 4.0vw, 4rem);\n        border-radius: 2rem;\n        border: none;\n        text-transform: uppercase;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: min(100%, 350px);\n        font-weight: 600;\n        cursor: pointer;\n        letter-spacing: 0.05rem;\n        padding: 0 1.2rem;\n        transition: all 0.3s ease;\n        gap: 1.2rem;\n        font-size: clamp(0.8rem, 1vw, 1rem);\n\n        &:hover {\n          background-color: #000;\n          transform: translateY(-2px);\n        }\n\n        .find_btn_icon {\n          font-size: clamp(1.2rem, 1.8vw, 1.8rem);\n        }\n      }\n\n      a {\n        display: inline-flex;\n        align-items: center;\n        margin-top: 1.5rem;\n        cursor: pointer;\n        text-decoration: none;\n        color: #000;\n        transition: all 0.3s ease;\n        font-size: clamp(0.9rem, 1.2vw, 1.2rem);\n        gap: 0.5rem;\n\n        .row_text_icon {\n          color: $orange;\n          font-size: clamp(1.2rem, 1.8vw, 1.8rem);\n          transition: all 0.3s ease;\n          margin-left: 1rem;\n        }\n\n        &:hover {\n          text-decoration: underline;\n          text-underline-offset: 0.3rem;\n\n          .row_text_icon {\n            color: #000;\n            transform: scale(1.1);\n          }\n        }\n      }\n    }\n\n    img {\n      // height: min(50%,100px);\n      width: 60%;\n      object-fit: contain;\n      // border-radius: 0.5rem;\n    }\n\n    @media (max-width: 1024px) {\n      gap: 3rem;\n\n      .home_row_column {\n        h1 {\n          font-size: clamp(1.8rem, 3.2vw, 2.5rem);\n        }\n\n        h5 {\n          margin-bottom: 1.5rem;\n        }\n      }\n    }\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 2rem;\n      padding: 0 0%;\n\n      .home_row_column {\n        align-items: center;\n        text-align: center;\n        width: 100%;\n\n        h1 {\n          text-align: center;\n          font-size: clamp(1.6rem, 5vw, 2.2rem);\n        }\n\n        h5 {\n          text-align: center;\n          font-size: clamp(1rem, 3.5vw, 1.4rem);\n        }\n\n        .find__btn {\n          width: 100%;\n          max-width: 280px;\n        }\n      }\n\n      img {\n        width: 100%;\n        // max-width: 500px;\n        margin: 0 auto;\n        // order: -1;\n      }\n    }\n\n    @media (max-width: 480px) {\n      // padding: 0 1px;\n      padding: 0 0%;\n      margin-left: 0%;\n      .home_row_column {\n        h1 {\n          font-size: clamp(1.4rem, 6vw, 1.8rem);\n          line-height: 1.3;\n        }\n\n        .find__btn {\n          height: 2.8rem;\n          font-size: 0.75rem;\n        }\n      }\n    }\n  }\n\n  .home__banner {\n    background-color: $orange;\n    color: #fff;\n    width: 100vw;\n    align-items: center;\n    text-align: center;\n\n    p {\n      font-size: 2rem;\n      font-weight: 700;\n    }\n\n    @media (min-width: $smallScreen) and (max-width: 1900px) {\n      margin-top: -0.5%;\n      width: 100vw;\n    }\n\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n      p {\n        font-size: 1.5rem;\n      }\n    }\n\n    @media (min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n      margin-top: -1%;\n\n      p {\n        font-size: 1.8rem;\n      }\n    }\n\n    @media (max-width: $mobile) {\n      width: 100vw;\n\n      p {\n\n        font-size: 1.2rem;\n      }\n    }\n  }\n\n  .home__why {\n    @include columnStack;\n    width: 80vw;\n    margin: 0 auto;\n\n    h2 {\n      font-size: 3rem;\n\n      span {\n        color: $orange;\n      }\n    }\n\n    .home_why_row {\n      @include rowBetweenStart;\n      font-size: 1.15rem;\n      margin-bottom: 2%;\n      flex-wrap: wrap;\n\n      .why_reason {\n        @include columnStack;\n        width: 30%;\n        text-align: center;\n        margin-bottom: 3%;\n\n        img,\n        .why_icon {\n          height: 4rem;\n          color: $orange;\n          font-size: 4rem;\n        }\n\n        p {\n          text-align: center;\n          width: 100%;\n          // margin: 5%;\n          padding: 0% 5%;\n\n          span {\n            color: $orange;\n          }\n        }\n      }\n\n      @media (min-width: $smallScreen) and (max-width: 1900px) {\n        font-size: 1.1rem;\n\n        .why_reason {\n\n          img,\n          .why_icon {\n            height: 3.5rem;\n            font-size: 3.5rem;\n          }\n        }\n      }\n    }\n\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n      width: 90vw;\n\n      h2 {\n        font-size: 2rem;\n      }\n\n      .home_why_row {\n        font-size: 1rem;\n\n        .why_reason {\n\n          img,\n          .why_icon {\n            height: 3rem;\n            font-size: 3rem;\n          }\n        }\n      }\n    }\n\n    @media (min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n      h2 {\n        font-size: 2.3rem;\n      }\n\n      .home_why_row {\n        font-size: 1rem;\n\n        .why_reason {\n\n          img,\n          .why_icon {\n            height: 3.5rem;\n            font-size: 3.5rem;\n          }\n        }\n      }\n    }\n\n    @media (min-width: $smallLaptopMin) and (max-width: $smallLaptopMax) {\n      h2 {\n        font-size: 2.3rem;\n      }\n\n      .home_why_row {\n        font-size: 1rem;\n\n        .why_reason {\n\n          img,\n          .why_icon {\n            height: 3.5rem;\n            font-size: 3.5rem;\n          }\n        }\n      }\n    }\n\n    @media (max-width: $mobile) {\n      h2 {\n        font-size: 1.8rem;\n      }\n\n      .home_why_row {\n        font-size: 1rem;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        padding: 0%;\n\n        .why_reason {\n          flex: 150px;\n          margin-bottom: 5%;\n\n          strong {\n            font-size: 1.2rem;\n          }\n\n          img,\n          .why_icon {\n            height: 2.5rem;\n            font-size: 2rem;\n            margin-bottom: 20px;\n          }\n\n          p {\n            font-size: 0.9rem;\n            // text-align: justify;\n            // text-wrap: wrap;\n            // white-space: nowrap; /* Keeps text on a single line */\n            // overflow: hidden; /* Hides overflow */\n            // text-overflow: ellipsis;\n            word-wrap: break-word;\n            /* Breaks long words if needed */\n            // overflow-wrap: break-word; /* Modern alternative to word-wrap */\n            // word-break: break-all; \n          }\n\n        }\n      }\n    }\n  }\n//origina\n  .home__pricing1 {\n    position: relative;\n    width: 100vw;\n\n    .img_container {\n      position: absolute;\n      z-index: 0;\n      opacity: 0.2;\n      // width: 99vw;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 70vh;\n      overflow: hidden;\n    }\n\n    .home_pricing_content {\n      position: absolute;\n      z-index: 1;\n      @include columnStack;\n      width: 100%;\n\n      h2 {\n        font-size: 3rem;\n\n        span {\n          color: $orange;\n        }\n      }\n\n      .pricing_row {\n        @include rowEvenStart;\n        width: 100%;\n\n        .pricing_card {\n          background-color: #fff;\n          @include columnStack;\n          padding: 2% 0;\n          width: 25vw;\n          height: 52vh;\n\n          h2 {\n            text-transform: uppercase;\n            font-size: 2rem;\n          }\n\n          .card_icon {\n            font-size: 5rem;\n            color: $orange;\n          }\n\n          .img_icon {\n            position: relative;\n            height: 5rem;\n            width: auto;\n            opacity: 1;\n          }\n\n          .card__text {\n            @include columnStack;\n            // margin: 0 auto;\n            max-height: 30%;\n\n            strong {\n              font-size: 1.2rem;\n              margin-bottom: 2%;\n\n              span {\n                color: $orange;\n              }\n            }\n          }\n\n          .line_big {\n            border-bottom: 2px solid $orange;\n            width: 30%;\n            align-self: flex-start;\n            margin-top: 10%;\n          }\n\n          .line_small {\n            border-bottom: 2px solid $orange;\n            width: 20%;\n            align-self: flex-start;\n            margin-top: 3%;\n          }\n\n          em {\n            width: 60%;\n            text-align: center;\n            margin-top: 10%;\n          }\n        }\n      }\n\n      .pricing_content_dots {\n        display: none;\n      }\n    }\n\n    @media (min-width: $smallScreen) and (max-width: 1900px) {\n      .img_container {\n        // width: 99vw;\n        height: 83vh;\n      }\n\n      .home_pricing_content {\n        .pricing_row {\n          .pricing_card {\n            @include columnStartCenter;\n            height: 62vh;\n          }\n\n          .card__text {\n            height: 40%;\n          }\n\n          em {\n            margin-top: 12%;\n          }\n        }\n\n        .pricing_content_dots {\n          display: none;\n        }\n      }\n    }\n\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n      .img_container {\n        height: 52vh;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n      .home_pricing_content {\n        h2 {\n          font-size: 2rem;\n        }\n\n        .pricing_row {\n          .pricing_card {\n            height: 38vh;\n            @include columnStartCenter;\n\n            h2 {\n              font-size: 1.5rem;\n            }\n\n            .card_icon {\n              font-size: 4rem;\n            }\n\n            .img_icon {\n              height: 4rem;\n            }\n\n            .card__text {\n              height: 15%;\n\n              strong {\n                font-size: 1rem;\n                width: 90%;\n              }\n            }\n\n            em {\n              width: 80%;\n              text-align: center;\n              margin-top: 10%;\n            }\n          }\n        }\n\n        .pricing_content_dots {\n          display: none;\n        }\n      }\n    }\n\n    @media (min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n      .img_container {\n        height: 72vh;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n      .home_pricing_content {\n        h2 {\n          font-size: 2.3rem;\n        }\n\n        .pricing_row {\n          .pricing_card {\n            @include columnStartCenter;\n\n            h2 {\n              font-size: 1.8rem;\n            }\n\n            .card__text {\n              strong {\n                font-size: 1rem;\n              }\n            }\n\n            em {\n              width: 80%;\n              margin-top: 10%;\n            }\n          }\n        }\n\n        .pricing_content_dots {\n          display: none;\n        }\n      }\n    }\n\n    @media (min-width: $smallLaptopMin) and (max-width: $smallLaptopMax) {\n      .img_container {\n        height: 85vh;\n      }\n\n      .home_pricing_content {\n        h2 {\n          font-size: 2.3rem;\n        }\n\n        .pricing_row {\n          .pricing_card {\n            @include columnStartCenter;\n            height: 61vh;\n\n            h2 {\n              font-size: 1.8rem;\n            }\n\n            .card_icon {\n              font-size: 3rem;\n            }\n\n            .img_icon {\n              height: 3rem;\n            }\n\n            .card__text {\n              height: 15%;\n\n              strong {\n                font-size: 1rem;\n              }\n            }\n\n            em {\n              font-size: 0.9rem;\n            }\n          }\n        }\n      }\n    }\n\n    @media (max-width: $mobile) {\n      .img_container {\n        height: 68vh;\n\n      }\n\n      .home_pricing_content {\n        h2 {\n          font-size: 1.8rem;\n          text-align: center;\n        }\n\n        .pricing_row {\n          position: relative;\n          width: 100%;\n\n          .pricing_card {\n            position: absolute;\n            left: calc(0% + 10%);\n            width: 80%;\n            height: auto;\n            @include columnStartCenter;\n            opacity: 0;\n            padding-bottom: 20px;\n            animation: display 15s infinite;\n\n            h2 {\n              font-size: 1.6rem;\n            }\n\n            .card_icon {\n              font-size: 3rem;\n            }\n\n            .img_icon {\n              height: 3rem;\n            }\n\n            .card__text {\n              height: 15%;\n\n              strong {\n                font-size: 1rem;\n              }\n            }\n\n            em {\n              width: 90%;\n              text-align: center;\n              margin-top: 10%;\n              font-size: 0.9rem;\n            }\n\n            &:nth-child(2) {\n              animation-delay: 5s;\n            }\n\n            &:nth-child(3) {\n              animation-delay: 10s;\n            }\n          }\n        }\n\n        .pricing_content_dots {\n          display: flex;\n          position: absolute;\n          // margin-top: 100%;\n          top: 550px;\n\n          .content_dot {\n            opacity: 0.3;\n            animation: dotsAnim 5s infinite;\n\n            &:nth-child(2) {\n              animation-delay: 5s;\n            }\n\n            &:nth-child(3) {\n              animation-delay: 10s;\n            }\n          }\n        }\n      }\n    }\n\n    @media (min-width: $fourK) {\n      .img_container {\n        height: 85vh;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n      .home_pricing_content {\n        .pricing_row {\n          .pricing_card {\n            height: 45vh;\n            width: 18vw;\n          }\n        }\n      }\n    }\n  }\n\n//   .home__pricing {\n//     position: relative;\n//     width: 100vw;\n//     overflow: hidden;\n\n//     .img_container {\n//         position: absolute;\n//         z-index: 0;\n//         opacity: 0.2;\n//         width: 100%;\n//         height: 70vh;\n//         display: flex;\n//         justify-content: center;\n//         align-items: center;\n//         overflow: hidden;\n        \n//         img {\n//             width: 100%;\n//             height: 100%;\n//             object-fit: cover;\n//         }\n//     }\n\n//     .home_pricing_content {\n//         position: relative;\n//         z-index: 1;\n//         @include columnStack;\n//         width: 90%;\n//         margin: 0 auto;\n//         padding: 4rem 0;\n\n//         h2 {\n//             font-size: clamp(2rem, 3.5vw, 3.5rem);\n//             text-align: center;\n//             margin-bottom: 3rem;\n            \n//             span {\n//                 color: $orange;\n//             }\n//         }\n\n//         .pricing_row {\n//           .pricing_row {\n//             position: relative;\n//             width: 100%;\n//             min-height: 52vh;\n//             overflow: hidden; // Prevent content from overflowing\n\n//             @media (max-width: $mobile) {\n//                 display: flex;\n//                 overflow-x: auto;\n//                 scroll-snap-type: x mandatory;\n//                 -webkit-overflow-scrolling: touch;\n//                 scrollbar-width: none; // Hide scrollbar for Firefox\n//                 &::-webkit-scrollbar {\n//                     display: none; // Hide scrollbar for Chrome/Safari\n//                 }\n//             }\n\n//             .pricing_card {\n//                 background-color: #fff;\n//                 @include columnStack;\n//                 align-items: center;\n//                 padding: 2rem;\n//                 width: clamp(250px, 25vw, 350px);\n//                 height: 52vh;\n//                 border-radius: 0.5rem;\n//                 box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n//                 transition: all 0.3s ease;\n                \n\n//                 @media (max-width: $mobile) {\n//                   position: relative;\n//                   flex: 0 0 80%;\n//                   scroll-snap-align: center;\n//                   margin: 0 10%;\n//                   opacity: 1;\n//                   animation: none;\n//                   left: auto;\n//                   transform: none;\n                  \n//                   // Keep the animation for initial load\n//                   &:not(.active) {\n//                       opacity: 0;\n//                   }\n                  \n//                   &.active {\n//                       animation: fadeIn 1s forwards;\n//                   }\n//               }\n            \n//                 &:hover {\n//                     transform: translateY(-5px);\n//                     box-shadow: 0 6px 16px rgba(0,0,0,0.15);\n//                 }\n\n//                 h2 {\n//                     text-transform: uppercase;\n//                     font-size: clamp(1.5rem, 2vw, 2rem);\n//                     margin: 1rem 0;\n//                 }\n\n//                 .card_icon {\n//                     font-size: clamp(3rem, 5vw, 5rem);\n//                     color: $orange;\n//                     margin: 1rem 0;\n//                 }\n\n//                 .img_icon {\n//                     height: clamp(3rem, 5vw, 5rem);\n//                     width: auto;\n//                     margin: 1rem 0;\n//                 }\n\n//                 .card__text {\n//                     @include columnStack;\n//                     align-items: center;\n//                     width: 100%;\n//                     gap: 0.8rem;\n//                     margin: 1rem 0;\n\n//                     strong {\n//                         font-size: clamp(0.9rem, 1.1vw, 1.2rem);\n//                         text-align: center;\n                        \n//                         span {\n//                             color: $orange;\n//                             font-weight: 700;\n//                         }\n//                     }\n//                 }\n\n//                 .line_big {\n//                     border-bottom: 2px solid $orange;\n//                     width: 30%;\n//                     margin: 1.5rem 0;\n//                 }\n\n//                 .line_small {\n//                     border-bottom: 2px solid $orange;\n//                     width: 20%;\n//                     margin: 0.5rem 0;\n//                 }\n\n//                 em {\n//                     width: 80%;\n//                     text-align: center;\n//                     margin-top: 1rem;\n//                     font-size: clamp(0.9rem, 1.1vw, 1.1rem);\n//                     font-style: normal;\n//                     color: #555;\n//                 }\n\n//                 // Special styling for the heavy duty card with multiple icons\n//                 &[id=\"3\"] {\n//                     .img_icon, .card_icon {\n//                         height: clamp(2.5rem, 4vw, 4rem);\n//                         font-size: clamp(2.5rem, 4vw, 4rem);\n//                         margin: 0.5rem;\n//                     }\n//                 }\n//             }}\n//         }\n\n//         .pricing_content_dots {\n//             display: none;\n//             @media (max-width: $mobile) {\n//               .content_dot {\n//                   animation: none;\n//                   &.active {\n//                       color: $orange;\n//                       transform: scale(1.3);\n//                   }\n//               }\n//             }\n//         }\n//     }\n//     @keyframes fadeIn {\n//       from { opacity: 0; transform: translateX(-20px); }\n//       to { opacity: 1; transform: translateX(0); }\n//   }\n  \n//   @keyframes fadeInOut {\n//       0%, 20% { opacity: 0; transform: translateX(-20px); }\n//       5%, 15% { opacity: 1; transform: translateX(0); }\n//       100% { opacity: 0; transform: translateX(20px); }\n//   }\n//     @media (min-width: $smallScreen) and (max-width: 1900px) {\n//         .img_container {\n//             height: 83vh;\n//         }\n\n//         .home_pricing_content {\n//             .pricing_row {\n//                 .pricing_card {\n//                     height: 62vh;\n//                 }\n//             }\n//         }\n//     }\n\n//     @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n//         .img_container {\n//             height: 52vh;\n//         }\n\n//         .home_pricing_content {\n//             padding: 3rem 0;\n            \n//             .pricing_row {\n//                 .pricing_card {\n//                     height: 38vh;\n//                     padding: 1.5rem;\n                    \n//                     .card__text {\n//                         gap: 0.5rem;\n//                     }\n//                 }\n//             }\n//         }\n//     }\n\n//     @media (min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n//         .img_container {\n//             height: 72vh;\n//         }\n\n//         .home_pricing_content {\n//             .pricing_row {\n//                 .pricing_card {\n//                     height: 50vh;\n//                 }\n//             }\n//         }\n//     }\n\n//     @media (min-width: $smallLaptopMin) and (max-width: $smallLaptopMax) {\n//         .img_container {\n//             height: 85vh;\n//         }\n\n//         .home_pricing_content {\n//             .pricing_row {\n//                 .pricing_card {\n//                     height: 61vh;\n//                 }\n//             }\n//         }\n//     }\n\n//     @media (max-width: $mobile) {\n//         .img_container {\n//             height: 68vh;\n//         }\n\n//         .home_pricing_content {\n//             padding: 2rem 0;\n            \n//             .pricing_row {\n//                 min-height: 400px;\n                \n//                 .pricing_card {\n//                     position: absolute;\n//                     left: 10%;\n//                     width: 80%;\n//                     height: auto;\n//                     padding: 2rem 1.5rem;\n//                     opacity: 0;\n//                     animation: fadeInOut 15s infinite;\n                    \n//                     &:nth-child(1) {\n//                         animation-delay: 0s;\n//                     }\n//                     &:nth-child(2) {\n//                         animation-delay: 5s;\n//                     }\n//                     &:nth-child(3) {\n//                         animation-delay: 10s;\n//                     }\n//                 }\n//             }\n\n//             .pricing_content_dots {\n//                 display: flex;\n//                 justify-content: center;\n//                 gap: 1rem;\n//                 margin-top: 1.5rem;\n                \n//                 .content_dot {\n//                     font-size: 1rem;\n//                     color: rgba(0,0,0,0.2);\n//                     cursor: pointer;\n//                     transition: all 0.3s ease;\n//                     animation: dotPulse 5s infinite;\n                    \n//                     &:nth-child(1) {\n//                         animation-delay: 0s;\n//                     }\n//                     &:nth-child(2) {\n//                         animation-delay: 5s;\n//                     }\n//                     &:nth-child(3) {\n//                         animation-delay: 10s;\n//                     }\n//                 }\n//             }\n//         }\n//     }\n\n//     @media (min-width: $fourK) {\n//         .img_container {\n//             height: 85vh;\n//         }\n\n//         .home_pricing_content {\n//             .pricing_row {\n//                 .pricing_card {\n//                     width: 18vw;\n//                     height: 45vh;\n//                 }\n//             }\n//         }\n//     }\n// }\n\n.home__pricing2 {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n\n  .img_container {\n    position: absolute;\n    z-index: 0;\n    opacity: 0.2;\n    width: 100%;\n    // height: 70vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    \n    img {\n      width: 10%;\n      height: 10%;\n      // object-fit: cover;\n    }\n  }\n\n  .home_pricing_content {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin: 0 auto;\n    // padding: 4rem 0;\n\n    h2 {\n      font-size: clamp(2rem, 3.5vw, 3.5rem);\n      text-align: center;\n      margin-bottom: 3rem;\n      \n      span {\n        color: $orange;\n      }\n    }\n\n    .pricing_row {\n      position: relative;\n      width: 100%;\n      min-height: 52vh;\n\n      @media (max-width: $mobile) {\n        .img_container {\n                height: 68vh;\n        \n              }\n        display: flex;\n        overflow-x: auto;\n        scroll-snap-type: x mandatory;\n        -webkit-overflow-scrolling: touch;\n        scroll-behavior: smooth;\n        scrollbar-width: none;\n        &::-webkit-scrollbar {\n          display: none;\n        }\n      }\n\n      .pricing_card {\n        background-color: #fff;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 2rem;\n        width: clamp(250px, 25vw, 350px);\n        height: 52vh;\n        border-radius: 0.5rem;\n        box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n        transition: all 0.3s ease;\n        \n        @media (max-width: $mobile) {\n          flex: 0 0 80%;\n          scroll-snap-align: center;\n          margin: 0 10%;\n          height: auto;\n          min-height: 400px;\n          opacity: 0;\n          \n          &:nth-child(1) {\n            animation: fadeInOut 15s infinite 0s;\n          }\n          &:nth-child(2) {\n            animation: fadeInOut 15s infinite 5s;\n          }\n          &:nth-child(3) {\n            animation: fadeInOut 15s infinite 10s;\n          }\n          \n          &.active {\n            opacity: 1;\n            animation: none;\n          }\n        }\n\n        // ... (rest of your card styles)\n      }\n    }\n\n    .pricing_content_dots {\n      display: flex;\n          position: absolute;\n          // margin-top: 100%;\n          top: 550px;\n\n          .content_dot {\n            opacity: 0.3;\n            animation: dotsAnim 5s infinite;\n\n            &:nth-child(2) {\n              animation-delay: 5s;\n            }\n\n            &:nth-child(3) {\n              animation-delay: 10s;\n            }\n          }\n    }\n  }\n}\n\n@keyframes fadeInOut {\n  0%, 20% { opacity: 0; transform: translateX(-20px); }\n  5%, 15% { opacity: 1; transform: translateX(0); }\n  100% { opacity: 0; transform: translateX(20px); }\n}\n\n  .home__how {\n    @include columnStack;\n    // margin-top: 70vh;\n\n    h2 {\n      font-size: 3rem;\n\n      span {\n        color: $orange;\n      }\n    }\n\n    .home_how_cards {\n      display: grid;\n      grid-template-columns: repeat(4, 1fr);\n      gap: 5%;\n      width: 100%;\n      max-width: 1700px;\n      // margin: 0 auto;\n      padding: 0 15px;\n\n      .home_how_card {\n        width: 100%;\n        min-height: 35vh;\n        background-color: #f2f2f2;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        // justify-content: center;\n        padding: 10%;\n        box-sizing: border-box;\n\n        .how_card_icon {\n          font-size: 3.5rem;\n          margin-bottom: 15px;\n        }\n\n        .how_card_content {\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          align-items: center;\n          padding-bottom: 10px;\n        }\n\n        h3 {\n          color: $orange;\n          text-transform: uppercase;\n          font-size: 1.8rem;\n          margin: 10px 0;\n          text-align: center;\n        }\n\n        p {\n          width: 80%;\n          // margin: 10px 0;\n          text-align: center;\n        }\n      }\n    }\n\n    button {\n      @include button;\n      height: 2.5rem;\n      margin: 3% auto;\n    }\n\n    // Responsive Adjustments\n    // @media (max-width: 1900px) {\n    //   margin-top: 84vh;\n    // }\n\n    @media (max-width: $tabletMax) {\n      // margin-top: 50vh;\n\n      h2 {\n        font-size: 2rem;\n      }\n\n      .home_how_cards {\n        grid-template-columns: repeat(2, 1fr);\n       gap:4%;\n        .home_how_card {\n          \n          .how_card_icon {\n            font-size: 3rem;\n          }\n\n          h3 {\n            font-size: 1.5rem;\n          }\n        }\n      }\n    }\n\n    @media (max-width: $mobile) {\n      // margin-top: 66vh;\n\n      h2 {\n        font-size: 1.8rem;\n      }\n      button{\n        margin: 10% 0%;\n      }\n      .home_how_cards {\n        grid-template-columns: repeat(2, 1fr);\n        row-gap: 2%;\n        column-gap: 4%;\n        .home_how_card {\n          min-height: 25vh;\n          padding: 30px 5px;\n          // height: 100%;\n          justify-items: flex-start;\n\n          .how_card_icon {\n            font-size: 2.5rem;\n            align-items: flex-start;\n          }\n\n          h3 {\n            font-size: 1.2rem;\n          }\n\n          p {\n            font-size: 0.9rem;\n          }\n        }\n      }\n    }\n\n    @media (min-width: $fourK) {\n      // margin-top: 65vh;\n    }\n  }\n\n  .home__app {\n    @include rowEven;\n    width: 100vw;\n    background-color: #f2f2f2;\n\n    .home_app_text {\n      @include columnStart;\n      width: 30%;\n\n      h2 {\n        font-size: 3rem;\n\n        span {\n          color: $orange;\n        }\n      }\n\n      h6 {\n        font-size: 1.2rem;\n        font-weight: 400;\n      }\n\n      strong {\n        font-size: 2rem;\n      }\n\n      .text_row {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        width: 75%;\n        margin: 5% 0;\n\n        a {\n          img {\n            width: 90%;\n\n            &:first-child {\n              margin-right: 10%;\n            }\n          }\n        }\n      }\n    }\n\n    img {\n      width: 15%;\n    }\n\n    @media (min-width: $smallScreen) and (max-width: 1900px) {\n      width: 98.5vw;\n    }\n\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n      width: 99vw;\n\n      .home_app_text {\n        h2 {\n          font-size: 2rem;\n        }\n\n        h6 {\n          font-size: 1rem;\n        }\n\n        .text_row {\n          a {\n            img {\n              width: 80%;\n            }\n          }\n        }\n      }\n\n      img {\n        width: 20%;\n      }\n    }\n\n    @media (min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n      .home_app_text {\n        h2 {\n          font-size: 2.3rem;\n        }\n\n        h6 {\n          font-size: 1.2rem;\n        }\n\n        .text_row {\n          a {\n            img {\n              width: 70%;\n            }\n          }\n        }\n      }\n\n      img {\n        width: 16%;\n      }\n    }\n\n    @media (min-width: $smallLaptopMin) and (max-width: $smallLaptopMax) {\n      .home_app_text {\n        h2 {\n          font-size: 2.3rem;\n        }\n\n        h6 {\n          font-size: 1.2rem;\n        }\n\n        .text_row {\n          a {\n            img {\n              width: 70%;\n            }\n          }\n        }\n      }\n\n      img {\n        width: 16%;\n      }\n    }\n\n    @media (max-width: $mobile) {\n      @include columnStack;\n      width: 99vw;\n\n      .home_app_text {\n        width: 90%;\n\n        h2 {\n          font-size: 1.8rem;\n          align-self: center;\n        }\n\n        h6 {\n          font-size: 1rem;\n          margin-top: 0;\n          text-align: center;\n        }\n\n        strong {\n          align-self: center;\n          margin-top: 0;\n\n          font-size: 1.2rem;\n\n        }\n\n        .text_row {\n          align-self: center;\n          justify-content: center;\n\n          a {\n            margin-left: 10%;\n\n            img {\n              width: 95%;\n            }\n          }\n        }\n      }\n\n      #get_app_image {\n        display: none;\n      }\n    }\n  }\n\n  .home_laundry {\n    @include rowEven;\n    margin: 2% 0%;\n\n    h2 {\n      font-size: 3rem;\n      width: 25%;\n      text-align: center;\n\n      span {\n        color: $orange;\n      }\n    }\n\n    .home_laundry_text {\n      @include columnStack;\n      width: 30%;\n      text-align: center;\n\n      h3 {\n        text-transform: uppercase;\n        font-size: 2rem;\n        margin: 1% auto;\n\n        span {\n          color: $orange;\n        }\n      }\n\n      p {\n        margin: 0 auto 3% auto;\n      }\n    }\n\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n      h2 {\n        font-size: 2rem;\n      }\n\n      .home_laundry_text {\n        width: 35%;\n\n        h3 {\n          font-size: 1.3rem;\n        }\n\n        p {\n          font-size: 0.9rem;\n        }\n      }\n    }\n\n    @media (min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n      h2 {\n        font-size: 2.3rem;\n      }\n\n      .home_laundry_text {\n        h3 {\n          font-size: 1.8rem;\n        }\n\n        p {\n          font-size: 0.9rem;\n        }\n      }\n    }\n\n    @media (min-width: $smallLaptopMin) and (max-width: $smallLaptopMax) {\n      h2 {\n        font-size: 2.3rem;\n      }\n\n      .home_laundry_text {\n        h3 {\n          font-size: 1.8rem;\n        }\n\n        p {\n          font-size: 0.9rem;\n        }\n      }\n    }\n\n    @media (max-width: $mobile) {\n      @include columnStack;\n      width: 99vw;\n\n      h2 {\n        font-size: 1.8rem;\n        text-align: center;\n        width: 90%;\n      }\n\n      .home_laundry_text {\n        width: 95%;\n\n        h3 {\n          font-size: 1.2rem;\n        }\n\n        p {\n          font-size: 0.9rem;\n        }\n      }\n    }\n  }\n\n  .home__contact {\n    @include rowBetween;\n    width: 100%;\n    background-color: #f2f2f2;\n    padding: 2rem 0;\n\n    .home_contact_text {\n      width: 70%;\n      @include columnStack;\n      align-items: center;\n      padding: 0 2rem;\n\n      h2 {\n        font-size: clamp(1.8rem, 3vw, 3rem);\n        text-align: center;\n        margin-bottom: 1rem;\n\n        span {\n          color: $orange;\n        }\n      }\n\n      p {\n        font-size: clamp(1rem, 1.5vw, 2rem);\n        width: 80%;\n        text-align: center;\n        margin: 0;\n      }\n    }\n\n    .home_contact_form {\n      width: 50%;\n      padding: 0 2rem;\n\n      .form {\n        @include columnStart;\n        width: 100%;\n        max-width: 500px;\n\n        h3 {\n          font-size: clamp(1.3rem, 1.8vw, 2rem);\n          margin-bottom: 1.5rem;\n        }\n\n        .contact_names {\n          display: flex;\n          gap: 2rem;\n          width: 100%;\n          margin-bottom: 1rem;\n\n          .form_column {\n            width: 50%;\n            @include columnStart;\n\n            input {\n              width: 100%;\n              background-color: transparent;\n              border: none;\n              border-bottom: 2px solid #000;\n              height: 2.8rem;\n              padding: 0.5rem 0;\n              font-size: 1.2rem;\n\n              &:focus {\n                outline: none;\n                border-bottom: 2px solid $orange;\n              }\n            }\n          }\n        }\n\n        .form__field {\n          @include columnStart;\n          width: 100%;\n          margin-bottom: 1.5rem;\n\n          input,\n          textarea {\n            width: 100%;\n            background-color: transparent;\n            border: none;\n            border-bottom: 2px solid #000;\n            padding: 0.5rem 0;\n\n            &:focus {\n              outline: none;\n              border-bottom: 2px solid $orange;\n            }\n          }\n\n          textarea {\n            height: 6rem;\n            resize: vertical;\n          }\n        }\n\n        button {\n          @include button;\n          width: 100%;\n          max-width: 200px;\n          height: 2.5rem;\n          margin: 1rem auto 0;\n        }\n      }\n    }\n\n    // Responsive adjustments\n    @media (max-width: 690px) {\n      flex-direction: column;\n      // padding: 2rem 1rem;\n\n      .home_contact_text,\n      .home_contact_form {\n        width: 100%;\n        padding: 1rem;\n      }\n\n      .home_contact_form {\n        .form {\n          max-width: 100%;\n\n          .contact_names {\n            flex-direction: row;\n            gap: 1.5rem;\n\n            .form_column {\n              width: 100%;\n            }\n          }\n        }\n      }\n    }\n\n    @media (max-width: $mobile) {\n      .home_contact_text {\n        h2 {\n          font-size: 1.8rem;\n        }\n\n        p {\n          font-size: 1rem;\n        }\n      }\n\n      .home_contact_form {\n        .form {\n          h3 {\n            font-size: 1.5rem;\n          }\n\n          button {\n            width: 100%;\n            max-width: none;\n          }\n        }\n      }\n    }\n  }\n\n  // @media (max-width: $mobile) {\n  //   padding: 3%;\n  // }\n}\n\n.investors__page {\n  @include columnStack;\n  padding: 1%;\n\n  .investors {\n    width: 90%;\n    margin: 2% auto;\n    min-height: 53vh;\n\n    .investor_row {\n      @include rowCenter;\n\n      input {\n        border: none;\n        border-bottom: 2px solid $orange;\n        margin-left: 1%;\n\n        &:active,\n        &:focus,\n        &:hover {\n          outline: none;\n          border-bottom-color: $darkGrey;\n        }\n      }\n    }\n\n    .investor_pack {\n      @include columnStack;\n\n      h1 {\n        text-transform: uppercase;\n      }\n\n      .download__btn {\n        display: flex;\n        align-items: center;\n        font-family: inherit;\n        font-weight: 500;\n        font-size: 17px;\n        padding: 0.8em 1.5em 0.8em 1.2em;\n        color: white;\n        background: $orange;\n        border: none;\n        box-shadow: 0 0.7em 1.5em -0.5em $orange;\n        letter-spacing: 0.05em;\n        border-radius: 20em;\n        margin-bottom: 2%;\n\n        .btn_icon {\n          margin-right: 8px;\n        }\n\n        &:hover {\n          box-shadow: 0 0.5em 1.5em -0.5em $orange;\n        }\n\n        &:active {\n          box-shadow: 0 0.3em 1em -0.5em $orange;\n        }\n      }\n\n      img {\n        width: 50%;\n      }\n    }\n  }\n}","//colours\n$orange: #e63b11;\n$font: #000;\n$lightGrey: #d1d3d4;\n$darkGrey: #939598;\n$darkBlue: #01426a;\n$lightBlue: #77c5d5;\n\n//mobile breaks\n$mobilemin:100;\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1000px;\n$landsTabletMin2: 1000px;\n$landsTabletMax2: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin rowEven{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin button {\n        background-color: $orange;\n        color: #fff;\n        text-transform: uppercase;\n        border: none;\n        // height: 3rem;\n        border-radius: 1.5rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        // margin: 3% auto;\n        transition: background-color 0.3s ease;\n        padding: 0 2rem;\n        cursor: pointer;\n        \n        &:hover {\n          background-color: #000;\n        }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
